(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initReveal() {
    const selectors = [
      '.ssw-hero-copy',
      '.collection-hero__inner',
      '.card-wrapper',
      '.featured-collection .title-wrapper-with-link',
      '.template-product .product__info-wrapper',
      '.template-product .product__media-wrapper',
    ];

    const elements = document.querySelectorAll(selectors.join(','));
    if (!elements.length) return;

    elements.forEach((el) => el.classList.add('ssw-luxury-reveal'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -48px 0px', threshold: 0.12 }
    );

    elements.forEach((el) => observer.observe(el));
  }

  function initHeroShopScroll() {
    document.querySelectorAll('.ssw-hero-scroll-shop').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target =
          document.getElementById('ssw-home-shop') ||
          link.closest('.shopify-section')?.nextElementSibling;

        if (!target) return;

        event.preventDefault();

        const header = document.querySelector('.section-header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
      });
    });
  }

  function init() {
    initReveal();
    initHeroShopScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
